import entities from "./entities/en";
import globals from "./globals/en";
import pages from "./pages/en";
import enums from "./enums/en";

export default { entities, globals, pages, enums };
